import React from 'react';
import { Box } from '@mui/material';
import { MetricDisplay } from '../atoms/MetricDisplay';
import DomainIcon from '@mui/icons-material/Domain';
import { formatCurrencyWhole } from '../../../../../shared/utils/currency';

interface SiteMetricsDisplayProps {
  totalLabourPrice: number;
  plotCount: number;
}

export const SiteMetricsDisplay: React.FC<SiteMetricsDisplayProps> = ({
  totalLabourPrice,
  plotCount,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Box sx={{ flex: 1 }}>
        <MetricDisplay
          label="Total Value"
          value={formatCurrencyWhole(totalLabourPrice)}
          color="primary.main"
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <MetricDisplay
          label="Plots"
          value={plotCount}
          icon={<DomainIcon sx={{ fontSize: 14, color: 'text.secondary' }} />}
        />
      </Box>
    </Box>
  );
};
